export default __webpack_public_path__ + "74b379b96765eb418301a4dfd00f2532.svg";